import Link from 'next/link';

interface BreadcrumbItemType {
  label: string;
  href?: string;
}

interface BreadcrumbPropsType {
  items: BreadcrumbItemType[];
  className?: string;
}

const Breadcrumb = ({ items, className = '' }: BreadcrumbPropsType) => {
  return (
    <div
      className={`mb-5 flex items-center gap-3 text-sm md:mb-10 ${className} flex-wrap`}
    >
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-3">
          {item.href ? (
            <Link
              href={item.href}
              className="text-gray-500 transition-colors duration-200 hover:text-gray-800"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-400">{item.label}</span>
          )}
          {index < items.length - 1 && <span className="text-gray-400">›</span>}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
